export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14616.42cbed30.jpg";